import { LoanParams } from "app/models/loan-params";
import { Form } from "./interfaces";

export const resetInterest = (form: Form, loan?: LoanParams): void => {
    form.setFieldValue('interestBaseRate', Number(loan?.interestBaseRate) || 0);
    form.setFieldValue('interestBaseRateWithRounding', Number(loan?.interestBaseRateWithRounding) || 0);
    // Fallback derives from the ROUNDED base rate, the same way the ledger does.
    const bareAllInRate = Number(loan?.allInRate) || (
        Number(loan?.interestBaseRateWithRounding ?? form.values.interestBaseRateWithRounding) +
        Number(form.values.margin)
      )
    form.setFieldValue('allInRate', bareAllInRate + (Number(form.values.pikPremium) || 0))
    form.clearFieldError('contractPeriod');
    form.clearFieldError('startDate');
};
